import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Schedule from './pages/Schedule';
import Scores from './pages/Scores';
import Rankings from './pages/Rankings';
import SeasonStats from './pages/SeasonStats';
import WeeklyStats from './pages/WeeklyStats';
import Rulebook from './pages/Rulebook';
import PlayoffPicture from './pages/PlayoffPicture';
import SocialLinks from './pages/SocialLinks';
import AdminLogin from './pages/AdminLogin';
import PasswordReset from './pages/PasswordReset';
import AdminDashboard from './pages/AdminDashboard';
import LiveStreams from './pages/LiveStreams';
import VODArchive from './pages/VODArchive';
import ChatWidgetPage from './pages/ChatWidgetPage';
import DiscordCallback from './pages/DiscordCallback';
import AwardCandidates from './pages/AwardCandidates';
import { AdminAuthProvider } from './context/AdminAuthContext';
import { SeasonProvider } from './context/SeasonContext';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isChatWidget = location.pathname.startsWith('/chat-widget');

  if (isChatWidget) {
    return (
      <Routes>
        <Route path="/chat-widget/:streamId" element={<ChatWidgetPage />} />
      </Routes>
    );
  }

  return (
    <div className="app">
      <Header />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route path="/rankings" element={<Rankings />} />
          <Route path="/playoffs" element={<PlayoffPicture />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/scores" element={<Scores />} />
          <Route path="/stats" element={<SeasonStats />} />
          <Route path="/weekly-stats" element={<WeeklyStats />} />
          <Route path="/awards" element={<AwardCandidates />} />
          <Route path="/rulebook" element={<Rulebook />} />
          <Route path="/season/:seasonId/playoffs" element={<PlayoffPicture />} />
          <Route path="/social" element={<SocialLinks />} />
          <Route path="/live" element={<LiveStreams />} />
          <Route path="/vods" element={<VODArchive />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/password-reset" element={<PasswordReset />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/auth/discord/callback" element={<DiscordCallback />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AdminAuthProvider>
        <SeasonProvider>
          <AppContent />
        </SeasonProvider>
      </AdminAuthProvider>
    </Router>
  );
}

export default App;
